import { AxiosError } from 'axios';

export type globalType = {
  ErrorHandler?: ErrorHandler;
};
/* Error Sources */
export enum ErrorSource {
  LOGIN_AUTH = 'LOGIN_AUTH',
  LOGIN_USER_ACCT = 'LOGIN_USER_ACCT',
  LOGIN_AMBASSADOR_PROFILE = 'LOGIN_AMBASSADOR_PROFILE',
  LOGIN_COMPANY_HOST = 'LOGIN_COMPANY_HOST',
  USER_GET_ACCT = 'USER_GET_ACCT',
  ACCT_GET_NOTIF = 'ACCT_GET_NOTIF',
  ACCT_CHANGE_PASSWORD = 'ACCT_CHANGE_PASSWORD',
  ACCT_SAVE_AMBASSADOR = 'ACCT_SAVE_AMBASSADOR',
  ACCT_SAVE_NOTIFICATIONS = 'ACCT_SAVE_NOTIFICATIONS',
  ACCT_ACTIVATION_STATUS = 'ACCT_ACTIVATION_STATUS',
  CUSTOMER_ADVOCACY_GET_BADGES = 'LOYALTY_GET_BADGES',
  LOYALTY_GET_BADGES = 'LOYALTY_GET_BADGES',
  LOYALTY_GET_TIERS = 'LOYALTY_GET_TIERS',
  LOYALTY_GET_TASKS = 'LOYALTY_GET_TASKS',
  USER_SESSION = 'USER_SESSION',
  USER_REGISTER = 'USER_REGISTER',
  RESET_PASSWORD = 'RESET_PASSWORD',
  REDEEM_REWARD = 'REDEEM_REWARD',
  SAVE_SHARELINK = 'SAVE_SHARELINK',
  W9_TAX_CONTEXT = 'W9_TAX_CONTEXT',
}

export const NO_API_ERROR_MESSAGE = 'No API error was provided.';

/* Error Cause */
export enum ErrorCause {
  API_CALL = 'API_CALL',
  USER_ACTION = 'USER_ACTION',
  CHRON_JOB = 'CHRON_JOB',
}

type ApiMessageResult = {
  message: string;
  isApiMessage: boolean;
};

export class AmbassadorError {
  cause: ErrorCause;
  source: ErrorSource;
  stack: string;
  message: string;
  apiResponse?: object;
  isApiMessage: boolean;

  constructor(error: Error, source: ErrorSource, cause: ErrorCause, apiResponse?: object) {
    this.cause = cause;
    this.source = source;
    //TODO: Identify if its an API Error or Native Axios error to handle the message (ex: timeout error)
    const { message, isApiMessage } = this.getApiMessage(error as AxiosError);
    this.message = message;
    this.isApiMessage = isApiMessage;
    this.apiResponse = apiResponse && typeof apiResponse === 'object' ? apiResponse : undefined;
    this.stack = new Error().stack?.toString() as string;
  }

  private getApiMessage(e: AxiosError): ApiMessageResult {
    const errorData = e?.response?.data;
    if (!errorData || typeof errorData !== 'object') {
      return { message: e?.message || NO_API_ERROR_MESSAGE, isApiMessage: false };
    }
    const key = Object.keys(errorData)[0] as keyof typeof errorData; // casting key type
    const apiResponse: any = errorData[key]; //multiple possible types of response values

    if (typeof apiResponse == 'string') {
      return { message: apiResponse, isApiMessage: true };
    } else if (apiResponse instanceof Array) {
      return { message: apiResponse[0], isApiMessage: true };
    } else {
      return { message: NO_API_ERROR_MESSAGE, isApiMessage: false };
    }
  }
}

class ErrorHandler {
  constructor() {
    if ((global as globalType).ErrorHandler) {
      throw new Error('New instance cannot be created.');
    }
    (global as globalType).ErrorHandler = this;
  }
  getInstance() {
    return this;
  }

  get(e: AxiosError, source: ErrorSource, cause: ErrorCause, apiResponse?: object): AmbassadorError {
    return new AmbassadorError(e, source, cause, apiResponse);
  }

  create(message: string, source: ErrorSource, cause: ErrorCause): AmbassadorError {
    return new AmbassadorError(new Error(message), source, cause, { detail: message });
  }
}

let ErrorHandlerSingleton;
if (!(global as globalType).ErrorHandler) ErrorHandlerSingleton = new ErrorHandler();
else ErrorHandlerSingleton = (global as globalType).ErrorHandler;
export default ErrorHandlerSingleton as ErrorHandler;
